<template>
    <div :class="customClass">
    <!-- Top Navigation -->
        <nav class="navbar bg-primary-gradient" >
            <div class="navbar-left">
                <template v-if="!timelineIsHomepage">
                    <!-- Menu Toggle -->
                    <div id="menu-toggle" @click.prevent="expandNav()">
                        <span class="top"></span>
                        <span class="middle"></span>
                        <span class="bottom"></span>
                    </div>
                </template>

                <h1 class="navbar-title" v-html="fullTitle"></h1>
            </div>

            <img src="img/logos/bayer-white.png" alt="Bayer" class="logo" />
        </nav>

        <template v-if="!timelineIsHomepage">
            <!-- Menu -->
            <aside id="menu" class="menu">
                <ul>
                    <!-- Search -->
                    <li class="menu-header" v-if="!currentRoute">
                        <div class="input-group search">
                            <form action="/search-results/" v-on:submit.prevent="navFormSubmit" class="app-form">
                                <input id="menu-search" type="text" placeholder="Search">
                                <span class="input-addon" @click="resetSearch"></span>
                                <input type="submit" class="visually-hidden" value="Submit" />
                            </form> 
                        </div>
                    </li>
                    <li class="menu-item">
                        <router-link to="/disease-state">Disease State</router-link>
                    </li>
                    <li class="menu-item">
                        <router-link to="/select-product">Product</router-link> 
                    </li>
                    <li class="menu-item">
                        <router-link to="/timeline">See All</router-link> 
                    </li>
                    <li class="menu-item">
                        <a href="/" @click.prevent="clearDisclaimerShown"><i class="icon icon-home"></i> Home</a>
                    </li> 
                </ul>
            </aside>
            <div id="menu-overlay"></div>

        </template>

        <template v-if="(timelineIsHomepage && !currentRouteIsTimeline) || !currentRouteIsTimeline">
            <a @click="goBack" class="back-button"><img src="img/ui-elements/back-arrow.png" alt="Back" class="back-arrow"></a>
        </template>
    </div>
</template>

<script> 
    export default {
        name: 'NavBar',
        props: {
            title: {
                type: String
            },
            customClass: {
                type: String,
                default: ''
            }
        },
        computed: {
            currentRoute: function(){
                return this.$route.name == 'Search';
            },
            timelineIsHomepage: function(){
                //If localstorage item is not null, timeline is the homepage 
                return window.localStorage.getItem('appHomepageStatus') !== null;
            },
            currentRouteIsTimeline: function() {
                return this.$route.path == 'Timeline'; 
            },
            // If a matching productName is found, append its field_black_triangle_for_product value to the title
            fullTitle() {
                let title = this.title;

                const productNames = this.$store.getters.getProductNames;
                const product = productNames.filter(product => {
                    return product.title[0].value.trim() === this.title;
                });

                if (product[0] && product[0].field_black_triangle_for_product[0]) {
                    title += product[0].field_black_triangle_for_product[0].value;
                }

                return title;
            },
        },
        methods: {
            clearDisclaimerShown() {
                this.$store.dispatch('clearDisclaimerStatus')
                    .then( () => {
                        this.$router.push('/');
                    })

            },
            goBack() {
                this.$router.go(-1);
            },
            resetSearch(event) {
                let parent = event.target.closest('.app-form'); 
                
                let inp = parent.querySelector('input[type="text"]');
                inp.value =''; 
                inp.focus();
                
            },
            expandNav: function() {
                 let menu = document.getElementById('menu'); 
                 let menuOverlay = document.getElementById('menu-overlay'); 
                 let menuToggle = document.getElementById('menu-toggle'); 
                 menuToggle.classList.toggle('active');
                 menu.classList.toggle('active'); 
                 menuOverlay.classList.toggle('active');
            },
            navFormSubmit: function(){
                let el = document.getElementById('menu-search'); 
                let value = el.value; 
                
                this.$router.push({
                    path: '/search-results/'+value
                })
            },
        }
    }
</script>

<style scoped>
    .visually-hidden { /* https://snook.ca/archives/html_and_css/hiding-content-for-accessibility */
       position: absolute !important;
        height: 1px; width: 1px;
        overflow: hidden;
        clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
        clip: rect(1px, 1px, 1px, 1px);
    }
</style>